import { useEffect, useState } from "react";
import { toast } from "sonner";
import { ChevronDown } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { PTYPE } from "./whApi";

export function PricingRules() {
  const [open, setOpen] = useState(false);
  const [r, setR] = useState(null);
  useEffect(() => { if (open && !r) api.get("/admin/pricing").then((x) => setR(x.data)).catch(() => {}); }, [open, r]);
  const save = async () => {
    try { const { data } = await api.put("/admin/pricing", { ...r, markup: Object.fromEntries(Object.entries(r.markup).map(([k, v]) => [k, +String(v).replace(",", ".") || 1])) }); setR(data); toast.success("Regole prezzo salvate"); } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div className="rounded-xl border bg-white" data-testid="pricing-rules">
      <button data-testid="pricing-rules-toggle" onClick={() => setOpen(!open)} className="w-full px-4 h-11 flex items-center justify-between text-sm font-bold uppercase">Regole prezzo di vendita proposto <ChevronDown className={`w-4 h-4 transition-transform ${open ? "rotate-180" : ""}`} /></button>
      {open && r && (
        <div className="px-4 pb-4 space-y-3">
          <p className="text-xs text-slate-600">Prezzo proposto = costo × ricarico per tipo, IVA inclusa, arrotondato a ,90. Se il fornitore indica un prezzo consigliato, quello fa da tetto.</p>
          <div className="flex flex-wrap gap-3">
            {Object.entries(PTYPE).map(([k, l]) => (
              <label key={k} className="text-xs flex items-center gap-1">{l} ×<input data-testid={`pricing-markup-${k}`} value={r.markup[k] ?? ""} onChange={(e) => setR({ ...r, markup: { ...r.markup, [k]: e.target.value } })} className="h-8 w-16 px-2 rounded border text-sm" /></label>
            ))}
          </div>
          <div className="flex flex-wrap gap-4 text-sm">
            <label className="flex items-center gap-1.5"><input type="checkbox" checked={r.round90} onChange={(e) => setR({ ...r, round90: e.target.checked })} /> Arrotonda a ,90</label>
            <label className="flex items-center gap-1.5"><input type="checkbox" checked={r.cap_suggested} onChange={(e) => setR({ ...r, cap_suggested: e.target.checked })} /> Non superare il prezzo consigliato</label>
          </div>
          <button data-testid="pricing-save" onClick={save} className="press h-9 px-4 rounded bg-brand-yellow text-brand-navy text-sm font-bold">Salva regole</button>
        </div>
      )}
    </div>
  );
}
